export const environment = {
    production: true,
    auth: {
        audience: 'https://nyx.ares.sale',
        domain: 'auth.ares.sale',
        clientId: 'E6TXwSrNDpw9EHKMpPr6aDWQq5wBzFyB',
        cookieDomain: '.ares.sale'
    },
    nyx: {
        http: 'https://prod.nyx.ares.sale/graphql',
        ws: 'wss://prod.nyx.ares.sale/graphql',
    },
    imgix: {
        baseUrl: 'https://ares.imgix.net',
    },
};
